<template>
  <div v-if="visible" class="onboarding-loading-overlay">
    <div class="onboarding-loading-spinner">
      <div class="spinner"></div>
      <span class="loading-percent">{{ simulatedProgress }}%</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoadingSpinner',

  props: {
    show: {
      type: Boolean,
      default: false
    },
    message: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      visible: false,
      simulatedProgress: 0
    }
  },

  watch: {
    show: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this._startProgress()
        } else {
          this._completeProgress()
        }
      }
    }
  },

  methods: {
    _startProgress() {
      this.simulatedProgress = 0
      this.visible = true
      this._stopProgress()
      this._progressTimer = setInterval(() => {
        if (this.simulatedProgress < 85) {
          const remaining = 85 - this.simulatedProgress
          this.simulatedProgress = Math.min(85, Math.round(this.simulatedProgress + remaining * 0.06))
        }
      }, 120)
    },

    _completeProgress() {
      this._stopProgress()
      if (!this.visible) return
      this.simulatedProgress = 100
      setTimeout(() => {
        this.visible = false
        this.simulatedProgress = 0
      }, 350)
    },

    _stopProgress() {
      if (this._progressTimer) {
        clearInterval(this._progressTimer)
        this._progressTimer = null
      }
    }
  },

  beforeDestroy() {
    this._stopProgress()
  }
}
</script>

<style scoped lang="scss">
.onboarding-loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(2px);
}

.onboarding-loading-spinner {
  text-align: center;
  color: white;

  .spinner {
    width: 44px;
    height: 44px;
    border: 4px solid rgba(255, 255, 255, 0.25);
    border-top: 4px solid white;
    border-radius: 50%;
    animation: spin 1s linear infinite;
    margin: 0 auto 14px;
  }

  .loading-percent {
    display: block;
    font-size: 20px;
    font-weight: 600;
    letter-spacing: 1px;
    line-height: 1;
    opacity: 0.9;
    margin-left: 4px;
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
